(() => {
  const initializeCarousel = (section) => {
    if (!section || section.dataset.oixSliderStarted === 'true' || typeof window.Swiper !== 'function') return;

    const container = section.querySelector('.swiper-carousel');
    const wrapper = section.querySelector('.product-carousel__wrapper');
    const slides = section.querySelectorAll('.swiper-slide');
    const nextButton = section.querySelector('.swiper-button-next__prod');
    const previousButton = section.querySelector('.swiper-button-prev__prod');
    if (!container || !wrapper || !slides.length) return;

    const requestedCount = Number.parseFloat(wrapper.dataset.count || '4');
    const desktopSlides = Number.isFinite(requestedCount) ? requestedCount + 0.1 : 4.1;

    const swiper = new window.Swiper(container, {
      centeredSlides: false,
      slidesPerView: 1.1,
      waitForTransition: false,
      watchSlidesProgress: true,
      updateOnWindowResize: true,
      preloadImages: true,
      allowTouchMove: true,
      spaceBetween: 4,
      navigation: {
        nextEl: nextButton,
        prevEl: previousButton
      },
      breakpoints: {
        990: { slidesPerView: 2.1 },
        1200: { slidesPerView: 3.1 },
        1360: { slidesPerView: desktopSlides }
      },
      on: {
        slideChange() {
          const movingForward = this.activeIndex > this.previousIndex;
          const atStart = this.activeIndex === 0;
          const atEnd = nextButton?.classList.contains('swiper-button-disabled');

          container.classList.toggle('carousel_change-postion_next', atStart);
          container.classList.toggle('carousel_change-postion_prev', !atStart && movingForward);
          container.classList.toggle('carousel_change-postion_next-2', !atStart && !movingForward);

          slides.forEach((slide) => {
            slide.classList.toggle('slide_change-postion', !atStart && movingForward && !atEnd);
          });
          this.update();
        }
      }
    });

    section.dataset.oixSliderStarted = 'true';
    section.oixProductCarousel = swiper;

    const floatingContainer = section.querySelector('.button--with-underline--container');
    const floatingLink = floatingContainer?.querySelector('a');
    if (!floatingContainer || !floatingLink) return;

    const updateFloatingLink = (card) => {
      const productLink = card?.querySelector('.card-wrapper__link--overlay[href]');
      if (!productLink) return;
      floatingLink.href = productLink.href;
      floatingLink.setAttribute('aria-label', productLink.getAttribute('aria-label') || 'View product');
    };

    const showFloatingLink = (event) => {
      if (window.innerWidth <= 990) return;
      const card = event.target.closest('.collection-carousel-card');
      if (!card || !section.contains(card)) return;
      updateFloatingLink(card);
      floatingContainer.style.display = 'block';
    };

    const moveFloatingLink = (event) => {
      if (window.innerWidth <= 990 || floatingContainer.style.display !== 'block') return;
      floatingContainer.style.left = `${event.pageX}px`;
      floatingContainer.style.top = `${event.pageY + 30}px`;
    };

    const hideFloatingLink = () => {
      floatingContainer.style.display = '';
    };

    section.addEventListener('pointerover', showFloatingLink);
    section.addEventListener('focusin', showFloatingLink);
    section.addEventListener('pointermove', moveFloatingLink, { passive: true });
    section.addEventListener('pointerleave', hideFloatingLink);
    section.addEventListener('focusout', (event) => {
      if (!section.contains(event.relatedTarget)) hideFloatingLink();
    });
  };

  const initializeAllCarousels = (root = document) => {
    if (root.matches?.('.product-carousel-section')) initializeCarousel(root);
    root.querySelectorAll?.('.product-carousel-section').forEach(initializeCarousel);
  };

  document.addEventListener('DOMContentLoaded', () => initializeAllCarousels());
  document.addEventListener('shopify:section:load', (event) => initializeAllCarousels(event.target));
  initializeAllCarousels();
})();
